import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../AuthContext";
import ProRequestForm from "./ProRequestForm";

export default function PaywallModal({ open, onClose, communityId, featureLabel }) {
  const { t } = useTranslation();
  const { user } = useAuth();

  const effectiveCommunityId = useMemo(() => communityId || user?.communityId, [communityId, user?.communityId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("billing.paywall.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {featureLabel
            ? t("billing.paywall.subtitleWithFeature", { feature: featureLabel })
            : t("billing.paywall.subtitle")}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 2 }}>
          <Typography variant="body2">- {t("billing.paywall.benefit1")}</Typography>
          <Typography variant="body2">- {t("billing.paywall.benefit2")}</Typography>
          <Typography variant="body2">- {t("billing.paywall.benefit3")}</Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("billing.proRequest.modalIntro")}
        </Typography>
        <ProRequestForm communityId={effectiveCommunityId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t("common.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

